import Dropzone from "@/components/dropzone/DropZone";
import { Input } from "@thdinc/hpf-shared";
import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import { COCKTAILS_TYPES_DATA } from "@/constants/CompanyData";
import React, { useEffect, useState } from "react";
import { API_ROUTES } from "@/services/environment";
import { GET, PATCH_MULTIPART, POST_MULTIPART } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import useLoading from "@/hooks/useLoading";
import Alert from "@/components/alert/Alert";
import { useNavigate, useParams } from "react-router";
import ImageUploadFunDropZone from "@/constants/utils/ImageUploadDropZoneFun";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import IngredientTable from "@/pages/company/components/IngredientTable";
import IngrediantsBTC from "./IngrediantsBTC";
import { features } from "process";
import ToggleInput from "@/components/toggle/Toggle";

interface product {
  name: string;
  value: string;
  type: string;
}

interface props {
  businessId?: string;
}

interface ingredients {
  name?: string;
  qty_oz?: string;
  product_id?: string | null;
}

const EditCocktailBTC: React.FC<props> = () => {
  // const params = useParams();
  // const cocktailId = params.id;
  // const {
  //   state: { cocktailData },
  // } = useLocation();
  const dispatch = useDispatch();
  const { id: cocktailId } = useParams();

  const [cocktailData, setCocktailData] = useState<any>();
  const { refreshToken } = useAppSelector((store) => store.user);
  const { products, cocktail, getSingleCocktail } = API_ROUTES;
  const [isFeatured, setIsFeatured] = useState<boolean>(false);
  const [isPopular, setIsPopular] = useState<boolean>(false);
  const [cocktailImg, setCocktailImg] = useState<string | null>(null);
  const [cocktailImgFile, setCocktailImgFile] = useState<File | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [isCustomCocktail, setIsCustomCocktail] = useState<boolean>(false);
  const [cocktailName, setCocktailName] = useState<string>("");
  const [selectedType, setSelectedType] = useState<string>("");
  const [newIngredient, setNewIngredient] = useState<any>([]);
  const [productsList, setProductsList] = useState<product[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<product[]>([]); // products

  const [error, setError] = useState<string>("");
  const [imageError, setImageError] = useState<string>("");
  const navigate = useNavigate();
  const setNewIngredientFn = (value: any) => {
    const filtered = value.filter(
      (items: any) => items.qty_oz > 0 && items.name.length > 0
    );
    setNewIngredient(filtered);
  };
  const addCustomCocktail = () => {
    if (newIngredient && newIngredient.length <= 1) {
      setIsCustomCocktail((prevState) => {
        const newState = !prevState;
        if (newState) {
          const filtered = productsList.filter((p) => p.type === selectedType);
          setFilteredProducts(filtered);
        }
        else {
          setFilteredProducts(productsList)

        }
        return newState;
      });
    } else {
      if (isCustomCocktail) {
        setIsCustomCocktail(false);
        // setFilteredProducts([...productsList,{ value: "other", name: "other" ,type:''}])
      } else {
        Alert({
          type: "error",
          message: "Only one ingredient allowed in custom cocktail",
        });
      }
    }


  };

  useEffect(() => {
    const getProducts = async () => {
      try {
        const result = await GET(products, refreshToken);
        const prodcuts = Array.isArray(result?.data)
          ? result.data.map((product: any) => ({
            name: product.name,
            value: product.id,
            type: product.type,
          }))
          : [];

        setProductsList(prodcuts);

        setFilteredProducts(prodcuts);
      } catch (err) {
        console.log(String(err));
      }
    };
    getProducts();
    (async () => {
      // list of all coctails avaialble
      try {
        const { data } = await GET(
          `${getSingleCocktail}/${cocktailId}`,
          refreshToken
        );
        setCocktailName(data.name);
        setSelectedType(data.type);
        setIsFeatured(data.featured);
        setIsPopular(data.popular);
        setCocktailImg(data.image);
        setCocktailData(data);
        setIsCustomCocktail(data.is_custom_cocktail);
      } catch (err) {
        console.log(err);
        // setCustomError('discount', JSON.stringify( err));
      }
    })();
  }, []);
  const otherImagesUpload = (file: any) => {
    dispatch(formStateChange(true));
    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        setCocktailImgFile(f);
        setCocktailImg(URL.createObjectURL(f));
        setImageError("");
      }
    } catch (err: any) {
      console.log(err);
      setImageError(err.message);
    }
  };
  const saveCocktail = async (list: ingredients[]) => {
    dispatch(formStateChange(false));
    if (!cocktailImg) {
      setImageError("Provide cocktail image");
      return;
    }
    setImageError("");
    if (cocktailName == "") {
      setError("Provide cocktail name");
      return;
    }
    startLoading();

    const formData = new FormData();
    formData.append("business_id", cocktailData.business_id as string);
    formData.append("type", selectedType);
    formData.append("featured", isFeatured?.toString());
    formData.append("popular", isPopular?.toString());
    formData.append("name", cocktailName);
    formData.append("is_custom_cocktail", isCustomCocktail?.toString());
    // the list of selected ingredients
    list.map((item, index) => {
      formData.append(`ingredients[${index}][name]`, item.name ?? "");
      formData.append(`ingredients[${index}][qty_oz]`, item.qty_oz ?? "");
      formData.append(
        `ingredients[${index}][product_id]`,
        item.product_id ?? "null"
      );
    });
    // if image is selected
    if (cocktailImgFile) {
      formData.append("image", cocktailImgFile);
    }
    //  formData.append("ingredients", list);
    try {
      // create cocktail
      const result = await PATCH_MULTIPART(
        `${cocktail}/${cocktailId}`,
        formData,
        refreshToken
      );
      if (result.data.success) {
        Alert({ message: result.data.message });
      } else {
        Alert({ type: "error", message: result.data.message });
      }
    } catch (err) {
      console.log(String(err));
    } finally {
      stopLoading();
    }
  };


  return (
    <div className=" mx-auto  pt-5">
      <div>
        <div className="flex flex-col md:flex-row gap-5  min-h-[80vh]">
          {/* left sec */}
          <div className="md:w-6/12 flex flex-col gap-5  bg-white rounded-2xl  p-6">
            <div className="flex flex-col mt-4   items-center">
              <Dropzone
                image={cocktailImg}
                removeImage={() => {
                  setCocktailImg(null);
                }}
                onDrop={otherImagesUpload}
              ></Dropzone>
              {imageError && (
                <p className="text-primary-red text-xs ">{imageError}</p>
              )}
              <div className=" font-semibold my-2">Cocktail Image</div>
            </div>
            <div className="flex gap-4 items-center flex-col sm:flex-row">
              <div className="w-full ">
                <div className=" font-semibold my-2">Cocktail Name *</div>
                <Input
                  className="w-full px-4 py-[9px] bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  value={cocktailName}
                  maxLength={50}
                  onChange={(e) => {
                    dispatch(formStateChange(true));

                    setCocktailName(e.target.value), setError("");
                  }}
                  type="text"
                  placeholder="Cocktail Name"
                />
                {error && <p className="text-sm text-primary-red">{error}</p>}
              </div>
              <div className="w-full ">
                <div className=" font-semibold my-2">Type </div>
                <SelectSearchInput
                  placeholder="Select Type"
                  options={COCKTAILS_TYPES_DATA}
                  value={selectedType}
                  onChange={(selectedValue: string) => {

                    if (isCustomCocktail) {
                      if (selectedValue === 'other') {
                        setIsCustomCocktail(false)
                      } else {
                        const filtered = productsList.filter((p) => p.type === selectedValue);
                        setFilteredProducts(filtered);
                      }
                    }
                    setSelectedType(selectedValue);
                    dispatch(formStateChange(true));
                  }}
                />

                {/* <div className="flex gap-3 items-center text-sm text-primary-red mt-2 cursor-pointer">
                 <div
                   className="inline-block"
                   onClick={() => setAddTypeForm(!addtypeForm)}
                 >
                   <AddIcon />
                 </div>
                 <p>Add Secondary Alcohol</p>
               </div> */}
              </div>
            </div>
            <div className="w-full flex flex-wrap items-start justify-between mt-4 gap-2">
              <div className={`flex  gap-2`}>
                <div
                  className={`flex  items-center gap-2  ${
                    isFeatured && "bg-[#ffeee5] "
                  } px-3 py-2 rounded-full`}
                >
                  <p className=" font-semibold mr-2">Featured</p>
                  <Input
                    className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                    type="checkbox"
                    title="Featured"
                    checked={isFeatured}
                    onChange={(e) => {
                      dispatch(formStateChange(true));

                      setIsFeatured(e.target.checked);
                    }}
                  />
                </div>
                <div
                  className={`flex  items-center gap-2  ${
                    isPopular && "bg-[#ffeee5] "
                  } px-3 py-2 rounded-full`}
                >
                  <p className=" font-semibold mr-2">Popular</p>
                  <Input
                    className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                    type="checkbox"
                    title="Popular"
                    checked={isPopular}
                    onChange={(e) => {
                      dispatch(formStateChange(true));

                      setIsPopular(e.target.checked);
                    }}
                  />
                </div>
              </div>
              {selectedType !== 'other' && <div className="flex items-center gap-2 px-3 py-2 flex-wrap">
                <p className=" font-semibold mr-2">Custom Cocktail</p>
                <ToggleInput
                  onChange={() => addCustomCocktail()}
                  checked={isCustomCocktail}
                />
              </div>}
            </div>

            {/* optional form part */}
            {/* {addtypeForm && (
               <div className="w-full  ">
                 <div className=" font-semibold my-2">Alcohol Type </div>
                 <Input
                   onChange={(e) => {
                     setTypeInput(e.target.value);
                   }}
                   value={typeInput}
                   type="text"
                   placeholder="Alcohol Type"
                 />
                 <div className="text-end">
                   <Button classes="mt-2 " onClick={addNewAlcoholType}>
                     Save
                   </Button>
                 </div>
               </div>
             )} */}

            {/* <div className="w-full ">
               <div className=" font-semibold my-2">Brand</div>
               <SelectInput
                 disabled={false}
                 options={cocktailBrandsData}
                 value={"Cognac"}
                 onChange={(selectedValue: string) => {
                   console.log("de");
                 }}
               />
             </div> */}
          </div>
          {/* right */}
          <div className="md:w-5/12 flex-1 flex flex-col gap-5 bg-white rounded-2xl  p-6 ">
            {productsList.length > 0 &&
              cocktailData?.ingredients?.length > 0 && (
                <IngrediantsBTC
                  isCustomCocktail={isCustomCocktail}
                  CurInggrediant={cocktailData?.ingredients}
                  loading={isLoading}
                  saveCocktail={saveCocktail}
                  productsList={filteredProducts}
                  setNewIngredientFn={setNewIngredientFn}
                />
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCocktailBTC;
